import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Layout from '../../layout/Layout';
import Card from '../../components/Card/Card';
import EmptyAvatar from '../../assets/images/emptyAvatar.png';
import { ReactComponent as IconUser } from '../../assets/icon/ic_user.svg';
import { ReactComponent as IconEmail } from '../../assets/icon/ic_email.svg';
import { MEDIA_URL } from '../../constants/api';
import Text from '../../components/Text/Text';
import TabNavigation from '../../components/TabNavigation/TabNavigation';
import { profileNavigationTabs, profileNavigationTabsType } from '../../common/profileNavigationTabs';
import ProfileOverview from './components/ProfileOverview';
import ProfileEdit from './components/ProfileEdit';
import ProfileSkeleton from './skeleton';
import routes from '../../router/routes';
import { setApplicationState } from '../../actions/application/application';

const Profile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    application: { profileActiveTab },
    getMyProfile: {
      user = {},
      loading
    } = {}
  } = useSelector((state) => ({
    getMyProfile: state.getMyProfile,
    application: state.application
  }), shallowEqual);
  const {
    id,
    avatar,
    name,
    email,
    last_name: lastName,
    role: { name: roleName } = {}
  } = user;

  const breadcrumbs = {
    pageTitle: 'Account Overview',
    history: [
      {
        title: 'Home',
        onClick: () => navigate('/')
      },
      {
        title: 'User management',
      },
      {
        title: 'Users',
        onClick: () => navigate(routes.USERS)
      },
      {
        title: `${name} ${lastName || ''}`,
      }
    ]
  };

  return (
    <Layout breadcrumbs={breadcrumbs}>
      <div className="flex-1">
        {loading && !id ? <ProfileSkeleton /> : (
          <>
            <Card styleContainer="mb-10">
              <div className="flex flex-row mb-[23px]">
                <div>
                  <img
                    src={avatar ? `${MEDIA_URL}/${avatar}` : EmptyAvatar}
                    alt="avatar"
                    className="w-40 h-40 rounded-[8px] mr-[23px]"
                  />
                </div>
                <div>
                  <Text text={`${name || ''} ${lastName || ''}`} bold textStyle="text-background-dark text-[17px]" />
                  <div className="flex flex-row">
                    <Text
                      muted
                      text={roleName}
                      textStyle="first-letter:uppercase font-medium text-[#A1A5B7] mr-[10px]"
                      leftIcon={<IconUser className="text-[#A1A5B7] fill-[#A1A5B7] w-[14px]" />}
                    />
                    <Text
                      muted
                      text={email}
                      textStyle="first-letter:uppercase font-medium text-[#A1A5B7] mr-[10px]"
                      leftIcon={<IconEmail className="text-[#A1A5B7] fill-[#A1A5B7] w-[14px]" />}
                    />
                  </div>
                </div>
              </div>
              <TabNavigation
                tabs={profileNavigationTabs}
                activeType={profileActiveTab}
                onClick={(type) => dispatch(setApplicationState({ profileActiveTab: type }))}
              />
            </Card>
            <div>
              {
                profileActiveTab === profileNavigationTabsType.OVERVIEW && <ProfileOverview />
              }
              {
                profileActiveTab === profileNavigationTabsType.SETTINGS && <ProfileEdit />
              }
            </div>
          </>
        )}
      </div>
    </Layout>
  );
};

export default Profile;
